import { get, patch } from "../../xhr/api";

export const getListNotifications = (page = 1) => {
  return get(`api/declaration-system/notifications?page=${page}`, {}, true);
};

export const getNotificationDetailes = (id) => {
  return get(`api/declaration-system/notifications/${id}`, {}, true);
};

export const markAsReadNotification = (id) => {
  return patch(`api/declaration-system/notifications/${id}/read`, {}, true);
};